import $ from 'cash-dom';
const paramsToAdd = ['_ptid','ptid', 'tp', 'utm_source', 'utm_medium', 'service'];
import 'core-js/web/url';
import 'core-js/web/url-search-params';

export default function init_params_pass() {
  if ($) {
    $(() => {
      // determine if we have service in URL
      const search = window.location.search;
      const searchParams = new URLSearchParams(search);
      const setParams = {};
      paramsToAdd
        .filter((p) => searchParams.has(p))
        .forEach((p) => {
          setParams[p] = searchParams.get(p);
        });
      //const serviceURL = searchParams.has('service') ? searchParams.get('service') : undefined;

      //console.log('Params: ', setParams);

      if (Object.keys(setParams).length > 0) {
        $('a').each((i, a) => {
          // get link href
          try {
            const href = $(a).attr('href');
            const url = new URL(href);
            if (url.protocol === 'http:' || url.protocol === 'https:') {
              //console.log('GOT LINK WITH', href);
              Object.keys(setParams).forEach((k) => {
                url.searchParams.set(k, setParams[k]);
              });
              url.searchParams.sort();
              //console.log('SET TO ', url.toString());
              $(a).attr('href', url.toString());
            }
          } catch (e) {
            console.warn('Error replacing a link', e);
          }
        });
      }
    });
  }
};
